import View from 'ln/view/View';
import Node from 'ln/node/Node';
import ListRenderer from "ln/list/ListRenderer";
import List from "ln/list/List";
import setup from 'ln/setup/setup';
import MediaSearchSequenceView from './MediaSearchSequenceView';
import { ISlide } from '../../course/slideview/SlideDetailView';
import CourseModel from 'typescript/src/course/models/CourseModel';
import Template from 'ln/template/TemplateManager';


export interface IAsset {
	id:string,
	name:string,
	file_name:string,
	ext:string
}

export interface ISequence {
	id:string,
	title:string,
	slides:ISlide[],
	files:IAsset[]
}

class MediaSearchView extends View {

	private sequenceListRenderer:ListRenderer<ISequence>;
	private sequenceList:List<ISequence>;

	private currentPage:number = 1;
	private itemsPerPage:number = 5;
	private numPages:number = 1;
	private currentSequences:ISequence[];

	public constructor( data:CourseModel[] ) {
		super( data );

		this.sequenceList = new List<ISequence>();
		this.defaultTemplate = 'krw.mediasearch';
	}

	public init() {

		this.sequenceListRenderer = new ListRenderer<ISequence>( this.node.one('.list') );
		this.sequenceListRenderer.source = this.sequenceList;

		this.sequenceListRenderer.defaultRender( function (seq:ISequence) {
			var sequence = new MediaSearchSequenceView( seq );
			sequence.render();
			return { node: sequence.node };
		});

		// display "no matching entries" if list is empty
		this.sequenceList.filled.add( function( items:ISequence[] ) {			
			this.node.js( 'empty' ).toggleClass( 'hidden', items.length > 0 );	
		}, this);
		
		this.node.js('search').click.add( this.searchSequences, this );
		this.node.js('input').native.addEventListener( 'keydown', ( e:KeyboardEvent ) => {
            if( e.key == 'Enter' ) this.searchSequences();
        });
		this.node.js('course-dropdown').native.addEventListener( 'change', ( e:KeyboardEvent ) => {
            this.searchSequences();
        });

		// render courses dropdown
		this.data.forEach( ( course:CourseModel ) => {
			var option = Node.fromHTML( '<option value="' + course.id + '">' + course.title + '</option>' );
			this.node.js( 'course-dropdown' ).append( option );
		});
		
	}

	private searchSequences(){
		this.node.js( 'search-spinner' ).removeClass( '-hidden' );
		this.node.one('.list' ).addClass( 'hidden' );
		this.node.js('empty' ).addClass( 'hidden' );
		this.node.js('paging').empty();
		this.node.js('paging').addClass('hidden');

		let select = this.node.js( 'course-dropdown' ).native as HTMLSelectElement;
		let queryString = ( this.node.js( 'input' ).value != '' ) ? this.node.js( 'input').value : '*'; 
		let queryData = {
			query: queryString,
			course_id: select.options[select.selectedIndex].value,
			time:'',
			resource:true
		}
		setup.route( 'api.searchsequences' ).send( JSON.stringify( queryData ) )
			.then( this.onSequences.bind( this ) )
			.catch( ( error ) => console.log( error ) );
		
	}

	private onSequences( sequences:ISequence[] ){
		// remove sequences without slides and assets
		this.currentSequences = sequences.filter( function( sequence ){
			return sequence.files.length > 0 || sequence.slides.length > 0;
		});

		this.node.js( 'search-spinner' ).addClass( '-hidden' );
		this.node.one('.list' ).removeClass( 'hidden' );

		// no results short-cut
		if( this.currentSequences.length == 0 ){
			this.sequenceList.fill( this.currentSequences );
			return;
		}

		// paginating - 5 items per page
		this.numPages = Math.ceil( this.currentSequences.length / this.itemsPerPage );
		

		// render paging
		for( var i = 0; i < this.numPages; i++ ){
			var pagingNode = Node.fromHTML( Template.render( 'krw.paging-item', { pagenumber: i + 1 } ) );
			if( i == 0 ) pagingNode.addClass( '-active' );
			pagingNode.click.add( this.onPagingClicked, this );
			this.node.js('paging').append( pagingNode );

		}
		var paging = this.node.js('paging');
		paging.one('.paging-button').addClass( '-active');
		paging.removeClass('hidden');

		this.showPage( this.currentPage );

	}

	private onPagingClicked( n:Node ){
		this.node.all( '.paging-button' ).forEach( ( button ) => {
			button.removeClass( '-active' );
		});
		n.addClass( '-active' );
		var pagenumber = parseInt( n.data.pagenumber );
		if( pagenumber != this.currentPage ) this.showPage( pagenumber );
	}
	
	private showPage( pagenumber:number ){
		this.currentPage = pagenumber;
		var start = ( pagenumber - 1 ) * this.itemsPerPage;
		var end = pagenumber * this.itemsPerPage;
		var sequences = this.currentSequences.slice( start, end );
		this.sequenceList.empty();
		this.sequenceList.fill( sequences );
	}

}

export default MediaSearchView;